export default __webpack_public_path__ + "components/app-store/static/ios-8241d26b4dfb5f16ea745d9ce821f85d.svg";